<template>
  <v-container>
    <v-row>
      <div class="d-flex justify-center title-row">
        <h2>Referenciák</h2>
      </div>

      <!-- LIST -->

      <v-col
        cols="12"
        lg="4"
        class="d-flex justify-center"
      >
        <v-card
          class="mx-auto"
          min-width="400"
          tile
        >
          <v-list-item
            two-line
            v-for="(item, idx) in references"
            :key="idx"
            @click="selectItem(item)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.Location }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.ImgFolder }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <!-- FORM -->

      <v-col
        cols="12"
        lg="8"
        class="d-flex justify-center"
      >
        <v-form
          ref="form"
          v-model="valid"
          class="form"
        >
          <v-text-field
            v-model="referencesForm.YearBuilt"
            :rules="requiredRules"
            :label="'Építés éve'"
            required
          ></v-text-field>
          <v-text-field
            v-model="referencesForm.Location"
            :rules="requiredRules"
            :label="'Helyszín'"
            required
          ></v-text-field>
          <v-text-field
            v-model="referencesForm.Type"
            :rules="requiredRules"
            :label="'Méret'"
            required
          ></v-text-field>
          <v-text-field
            v-model="referencesForm.ImgFolder"
            :rules="requiredRules"
            :label="'Képek könyvtárának neve'"
            required
          ></v-text-field>
          <v-textarea
            v-model="referencesForm.Info"
            name="input-7-1"
            :label="'Leírás'"
            :rules="requiredRules"
          ></v-textarea>
          <div>
            <v-btn
              outlined
              class="white--text"
              v-on:click.native="clearreferencesForm"
            >Új létrehozása</v-btn>
            <v-btn
              outlined
              class="white--text"
              :disabled="!valid"
              :loading="loadingAnimation"
              v-on:click.native="addActual"
            >Feltöltés</v-btn>
            <v-btn
              outlined
              class="red--text"
              :disabled="!valid"
              :loading="loadingAnimation"
              v-on:click.native="deleteActual"
            >Törlés</v-btn>
          </div>
        </v-form>
        <v-snackbar
          v-model="successSnackbar"
          color="snackbar-success"
        >
          Siker!
        </v-snackbar>
        <v-snackbar
          v-model="errorSnackbar"
          color="error"
        >
          Hiba történt!
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import "@firebase/auth";
import { db } from "@/main";

export default {
  data() {
    return {
      valid: false,
      successSnackbar: false,
      errorSnackbar: false,
      loadingAnimation: false,
      requiredRules: [v => !!v || "Kötelező"],
      references: [],
      referencesForm: {
        YearBuilt: "",
        ImgFolder: "",
        Info: "",
        Location: "",
        Type: "",
        id: ""
      }
    };
  },
  firestore() {
    return { references: db.collection("References") };
  },
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    },
    addActual() {
      console.log("referencesForm submitted", this.referencesForm);
      db.collection("References")
        .add( { YearBuilt: this.referencesForm.YearBuilt, ImgFolder: this.referencesForm.ImgFolder, Info: this.referencesForm.Info, Location: this.referencesForm.Location, Type: this.referencesForm.Type })
        .then(
          res => {
            this.successSnackbar = true;
            this.clearreferencesForm();
            // console.log("Done: ", res);
          },
          err => {
            this.errorSnackbar = true;
            console.log("error happened: ", err);
          }
        );
    },
    selectItem(item) {
      this.referencesForm.YearBuilt = item.YearBuilt;
      this.referencesForm.ImgFolder = item.ImgFolder;
      this.referencesForm.Info = item.Info;
      this.referencesForm.Location = item.Location;
      this.referencesForm.Type = item.Type;
      this.referencesForm.id = item.id;
    },
    clearreferencesForm() {
      this.referencesForm.YearBuilt = "",
      this.referencesForm.ImgFolder = "",
      this.referencesForm.Info = "",
      this.referencesForm.Location = "",
      this.referencesForm.Type = "";
    },
    deleteActual(){
      db.collection('References').doc(this.referencesForm.id).delete();
      this.clearreferencesForm();
    }
  }
};
</script>

<style scoped>
.form {
  width: 750px;
}
.title-row {
  width: 100%;
}
.logout-btn-row {
  justify-content: flex-end;
  margin-right: 2rem;
}
.v-list-item__content {
  cursor: pointer;
}
.v-btn {
  margin-left: 10px;
  margin-top: 20px;
}
</style>